import { useFormik } from "formik";
import React, { useEffect } from "react";
import PageWithCard from "../../components/infrastructure/PageWithCard";
import FormikSelectGroup from "../../components/formik/FormikSelectGroup";
import { ClipLoader } from "react-spinners";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import PrimaryButton from "../../components/infrastructure/Buttons/PrimaryButton";
import { fetchUsers, getUsers } from "../../app/reducers/Users/userSlice";
import { useNavigate } from "react-router-dom";
import { generateOptions } from "../../utils/Utils";
import {
  fetchLocations,
  getLocation,
} from "../../app/reducers/Location/locationSlice";
import {
  fetchPrintPOs,
  getPrintPO,
  reset,
  setEditId,
} from "../../app/reducers/PrintPurchaseOrder/printPurchaseSlice";
import { Edit2, Eye, Trash } from "react-feather";
import TableWithHeadingAndGlobalSearch from "../../components/Table/TableWithHeadingAndGlobalSearch";
import { useCallback } from "react";
import { useMemo } from "react";
import { useState } from "react";
import FormikMultiSelect from "../../components/formik/FormikMultiSelect";
import EditPrintOrder from "./EditPrintOrder";
import ViewPrintPanel from "./ViewPrintPanel";
import PaginationClassic from "../../components/pagination/PaginationClassic";
import ImageComponent from "../../components/ImageComponent";
// import ViewPurchasePanel from './ViewPurchasePanel'

const ViewPrintOrder = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);

  const [viewPurchaseModel, setViewPurchaseModalOpen] = useState(false);
  const [viewingParty, setViewingParty] = useState(null);

  useEffect(() => {
    dispatch(reset({}));
  }, []);

  useEffect(() => {
    dispatch(fetchUsers({ role: "manufacturer" }));
    dispatch(fetchPrintPOs({ populate: true }));
    dispatch(fetchLocations());
  }, []);
  const { users } = useSelector(getUsers);
  const { location } = useSelector(getLocation);
  const { printPO, loading: printPoLoading } = useSelector(getPrintPO);

  const handleSettled = async (rowData) => {
    // let data = {
    //     _id: rowData._id,
    //     status: "settled"
    // }
    // await dispatch(updateStatusGreyPurchaseOrder(data))
    // dispatch(fetchGreyPurchaseOrders({ manufacturer: rowData.manufacturer, location: rowData.location, status: rowData.status, populate: true }))
  };

  const columns = [
    {
      Header: "SRNO",
      Cell: (prop) => {
        const { data, row } = prop;
        return row.index + 1;
      },
    },
    {
      Header: "Photo",
      Cell: (prop) => {
        const { data, row } = prop;
        console.log(row);
        return (
          <ImageComponent
            src={row.original?.greyColorData?.image}
            style={{ width: "120px" }}
          />
        );
      },
    },
    {
      Header: "Manufacturer",
      Cell: ({ row }) => {
        return <span> {row.original.manufacturerData.name}</span>;
      },
    },
    {
      Header: "Grey Quality",
      accessor: "greyData.name",
    },
    {
      Header: "Grey Color",
      accessor: "greyColorData.color",
    },
    {
      Header: "Location",
      accessor: "locationData.name",
    },
    {
      Header: "Unit",
      accessor: "greyData.unit",
    },
    {
      Header: "Chalan",
      accessor: "chalan",
    },
    {
      Header: "Status",
      accessor: "status",
    },

    {
      Header: "Ordered Total",
      Cell: ({ row }) => {
        return (
          <span>
            {" "}
            {row.original.greyData.unit === "pcs"
              ? row.original.quantity
              : row.original.quantity.toFixed(2)}
          </span>
        );
      },
    },
    {
      Header: "Ordered Remaining",
      Cell: ({ row }) => {
        return (
          <span>
            {" "}
            {row.original.greyData.unit === "pcs"
              ? row.original.remaining
              : row.original.remaining.toFixed(2)}
          </span>
        );
      },
    },
    {
      Header: "Action",
      Cell: (prop) => {
        const { data, row } = prop;
        return (
          <div
            className="flex items-center gap-2"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <Eye
              size={18}
              color="green"
              onClick={() => {
                setViewPurchaseModalOpen(true);
                setViewingParty(row.original);
              }}
            />
            {/* <Edit2
                            color='blue'
                            onClick={() => {
                                dispatch(setEditId(row.original._id));
                            }}
                        />
                        {row.original.status == 'settled' ?
                            <div>Settled</div> :
                            <PrimaryButton onClick={() => handleSettled(row.original)}>Settled</PrimaryButton>
                        } */}
          </div>
        );
      },
    },
  ];

  const locationdata = useMemo(
    () => (location?.docs ? location.docs : []),
    [location]
  );

  const printPOData = useMemo(
    () => (printPO?.docs ? printPO.docs : []),
    [printPO]
  );
  // console.log(data,"dekhtehai")

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      location: [],
      status: [],
      manufacturer: [],
    },

    onSubmit: async (values, { resetForm }) => {
      const data = {
        location: { $in: values.location },
        status: { $in: values.status },
        manufacturer: { $in: values.manufacturer },
      };

      dispatch(
        fetchPrintPOs({
          ...data,
          populate: true,
        })
      );
    },
  });
  const debouncedSearch = useCallback(
    _.debounce((search, values) => {
      let data = {
        location: { $in: values.location },
        status: { $in: values.status },
        manufacturer: { $in: values.manufacturer },
      };

      dispatch(
        fetchPrintPOs({
          ...data,
          search: search,
          populate: true,
          status: { $in: values.status },
        })
      );
    }, 300),
    []
  );
  useEffect(() => {
    let data = {
      location: formik.values.location,
      status: formik.values.status,
      manufacturer: formik.values.manufacturer,
    };

    dispatch(
      fetchPrintPOs({
        ...data,
        populate: true,
        page,
      })
    );
  }, [page]);

  return (
    <>
      <ViewPrintPanel
        open={viewPurchaseModel}
        setOpen={setViewPurchaseModalOpen}
        party={viewingParty}
      />
      {/* <EditPrintOrder values={formik.values} /> */}
      <PageWithCard heading="View Print Order">
        <form onSubmit={formik.handleSubmit} className="flex flex-col gap-4">
          <FormikMultiSelect
            formik={formik}
            label="Manufacturer"
            name="manufacturer"
            options={generateOptions({
              array: users ? users.docs : [],
              valueField: "_id",
              labelField: "name",
            })}
            required
          />

          <FormikMultiSelect
            formik={formik}
            label="Location"
            name="location"
            required
            options={generateOptions({
              array: locationdata,
              valueField: "_id",
              labelField: "name",
            })}
          />

          <FormikMultiSelect
            formik={formik}
            label="Status"
            name="status"
            required
            options={generateOptions({
              array: [
                { label: "Pending", value: "pending" },
                { label: "Completed", value: "completed" },
                { label: "Incomplete", value: "incomplete" },
              ],
              valueField: "value",
              labelField: "label",
            })}
          />

          <div>
            <PrimaryButton type="submit">Submit</PrimaryButton>
          </div>
        </form>
        <TableWithHeadingAndGlobalSearch
          heading="Purchase Orders"
          data={printPOData}
          columns={columns}
          loading={printPoLoading}
          searchFunction={(value) => {
            debouncedSearch(value, formik.values);
          }}
        />
        <PaginationClassic paginationDetails={printPO} setPage={setPage} />
      </PageWithCard>
    </>
  );
};

export default ViewPrintOrder;
